import { Box } from '@customerio/pluma-components/react';

/** Message-channels step (consolidated flow). Placeholder — content lands with FPS-2865. */
export function ChannelsStep() {
  return <Box data-testid="signup-step-channels" />;
}
